import { ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { TMenuLink } from "./links";


type MenuLinkProps = {
    content: TMenuLink
    onClick?: () => void
}

const MenuLink = ({ content, onClick }: MenuLinkProps) => {
    const { pathname } = useLocation();

    const isActive = content.pattern.test(pathname);

    return (
        <div className="relative text-sm" onClick={onClick}>            
            {
                content.subMenus === undefined ? (
                    <Link 
                        to={content.path} 
                        className={twMerge(
                            "flex items-center space-x-4 px-4 py-2 w-full rounded-md",
                            isActive ? 
                            "text-primary bg-[#FFEFE0]" : 
                            "text-secondary/70 hover:bg-zinc-100"
                        )}
                    >
                        {content.icon}

                        <span>
                            {content.label}
                        </span>
                    </Link>
                ) : (
                    <div>
                        <Link
                            to={content.path} 
                            className={twMerge(
                                "flex justify-between items-center px-4 py-2 w-full rounded-md",
                                isActive ? 
                                "text-primary bg-[#FFEFE0]" : 
                                "text-secondary hover:bg-zinc-100"
                            )}
                        >
                            <div className="flex items-center space-x-4">
                                {content.icon}

                                <span>
                                    {content.label}
                                </span>
                            </div>

                            <ChevronDown 
                                className={twMerge(
                                    "h-4 w-4", isActive && "rotate-180"
                                )} 
                            />
                        </Link>

                        {
                            isActive && (
                                <div className="ml-4 my-2 space-y-1">
                                    {
                                        content.subMenus.map((menu, index: number) => (
                                            <Link 
                                                to={menu.path} 
                                                className={twMerge(
                                                    "flex items-center space-x-4 px-4 py-2 w-full rounded-md",
                                                    pathname == menu.path && "bg-zinc-200"
                                                )}
                                                key={index}
                                            >
                                                {menu.icon}
                                                <span>{menu.label}</span>
                                            </Link>
                                        ))
                                    }
                                </div>
                            )
                        }

                        {/* <Transition
                            show={isActivePath(content.path)}
                            as="div"
                            enter="transition ease-out duration-300"
                            enterFrom="transform opacity-0 scale-y-95"
                            enterTo="transform opacity-100 scale-y-100"
                            leave="transition ease-in duration-300"
                            leaveFrom="transform opacity-100 scale-y-100"
                            leaveTo="transform opacity-0 scale-y-95"
                        >
                            <div className="ml-4 my-2 space-y-1">
                                {
                                    content.subMenus.map((menu, index) => (
                                        <Link 
                                            to={menu.path ?? ""} 
                                            className={twMerge(
                                                "flex items-center space-x-4 px-4 py-2 w-full rounded-md text-primary",
                                                location.pathname == menu.path && "bg-primary-100"
                                            )}
                                            key={index}
                                        >
                                            {menu.icon}
                                            <span>{menu.label}</span>
                                        </Link>
                                    ))
                                }
                            </div>
                        </Transition> */}
                    </div>
                )
            }
        </div>
    )
}

export default MenuLink